import { combineReducers } from 'redux';
import Interview from './interviewReducer';
import Platform from './platformReducer';

const appReducer = combineReducers({ Interview, Platform });

const reducers = (state, action) => {
    return appReducer(state, action);
};

export default reducers;
